import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgbAccordionModule, NgbInputDatepicker, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { translationChunksConfig } from '@spartacus/assets';
import {
  AuthGuard,
  CmsConfig,
  ConfigModule,
  I18nModule,
  provideConfig,
} from '@spartacus/core';
import { OrderCoreModule } from '@spartacus/order/core';
import { OrderOccModule } from '@spartacus/order/occ';
import { IconModule } from '@spartacus/storefront';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { FluDashboardBannerModule } from '../shared/modules/flu-dashboard-banner/flu-dashboard-banner.module';
import { NeedToGoBackModule } from '../shared/modules/need-to-go-back/need-to-go-back.module';
import { ProductSearchModule } from '../shared/modules/product-search/product-search.module';
import { CustomPipesModule } from '../shared/pipes/custom-pipes.module';
import { ListOrdersComponent } from './list-orders/list-orders.component';
import { OrderDetailsComponent } from './order-details/order-details.component';
import { OrderHistoryDatepickerComponent } from "./order-history-datepicker/order-history-datepicker.component";
import { StatusesDropdownComponent } from "./statuses-dropdown/statuses-dropdown.component";
import { PaymentInformationComponent } from "../shared/components/payment-information/payment-information.component";
import { OrdersTableComponent } from "./orders-table/orders-table.component";

@NgModule({
  declarations: [ListOrdersComponent, OrderDetailsComponent],
	imports: [
		CommonModule,
		I18nModule,
		IconModule,
		NgSelectModule,
		FormsModule,
		NgbModule,
		RouterModule,
		BsDatepickerModule.forRoot(),
		BrowserAnimationsModule,
		NeedToGoBackModule,
		FluDashboardBannerModule,
		OrderCoreModule,
		OrderOccModule,
		FontAwesomeModule,
		CustomPipesModule,
		ProductSearchModule,
		ConfigModule.withConfig({
			cmsComponents: {
				AccountOrderHistoryComponent: {
          component: () =>
            import('./list-orders/list-orders.component').then(
              (m) => m.ListOrdersComponent
            ),
					guards: [AuthGuard],
				},
				AccountOrderDetailsOverviewComponent: {
          component: () =>
            import('./order-details/order-details.component').then(
              (m) => m.OrderDetailsComponent
            ),
					guards: [AuthGuard],
				},
				OrderHistoryBannerComponent: {
          component: () =>
            import('./list-orders/list-orders.component').then(
              (m) => m.ListOrdersComponent
            ),
				},
			},
		} as CmsConfig),
		BsDatepickerModule,
		OrderHistoryDatepickerComponent,
		NgbAccordionModule,
		NgbInputDatepicker,
		StatusesDropdownComponent,
		PaymentInformationComponent,
		OrdersTableComponent
	],
  providers: [
    provideConfig({
      i18n: {
        backend: {
          loadPath: 'i18n-assets/{{lng}}/{{ns}}.json',
        },
        chunks: translationChunksConfig,
      },
    }),
  ],
})
export class OrderHistoryModule {}
